import { cn } from "@/lib/utils";
import { type FormContentBlock as FormContentBlockT } from "@/payload-types";

type FormContentBlockProps = FormContentBlockT & {
	containerClassName?: string;
};

export const FormContentBlock: React.FC<FormContentBlockProps> = ({ content, containerClassName }) => {
	const title = content?.title?.trim();
	const description = content?.description?.trim();

	if (!title && !description) {
		return null;
	}

	return (
		<div className={cn("flex flex-col gap-2", containerClassName)}>
			{title ? <p className="h3">{title}</p> : null}
			{description ? <p>{description}</p> : null}
		</div>
	);
};
